import * as React from "react"
import { Box } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"

import { DateRangeBlock } from "@components"
import { DATE_PERIODS } from "@constants"
import { rangeDatesPricingDiscountOffersEvolution } from "./Ranges"
import { evolutionOffersCurrentPeriod } from "../../@signals"


export default function PriceDiscountOffersEvolutionChartToolbar({handleClick, dateRange, onChange}) {
    return <Box display="flex" gap={2} alignItems="center">
        <DateRangeBlock
            currentPeriodLabel={evolutionOffersCurrentPeriod.value}
            maxDays={30}
            value={dateRange}
            ranges={rangeDatesPricingDiscountOffersEvolution}
            onChange={onChange}
            onOk = { () => evolutionOffersCurrentPeriod.value = DATE_PERIODS.CUSTOM }
        />
        <IconSeeker 
            icon={'circle-xmark'} 
            sx={{ mr: 0.5, margin: .5, fontSize: '1.5rem', color: 'text.disabled' }} 
            tooltip={'Close Evolution Chart'}
            onClick={handleClick}
        />
    </Box>
}